import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DevPanelComponent } from './dev-panel.component';

@NgModule({
	declarations: [DevPanelComponent],
	imports: [CommonModule, FormsModule],
	exports: [DevPanelComponent],
})
export class DevPanelModule {}
